export const runCode = async (code) => {
  const res = await fetch("https://quantum-compiler.onrender.com/api/run", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
  const data = await res.json();
  return data.result;
};

export const getTimeComplexity = async (code) => {
  const res = await fetch("https://quantum-compiler.onrender.com/api/tc", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
  const data = await res.json();
  return data.result;
};

export const getSpaceComplexity = async (code) => {
  const res = await fetch("https://quantum-compiler.onrender.com/api/sc", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
  const data = await res.json();
  return data.result;
};

export const getOptimalCode = async (code) => {
  const res = await fetch("https://quantum-compiler.onrender.com/api/optimal", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
  const data = await res.json();
  return data.result;
};
